/* eslint-disable security/detect-object-injection */
// InputField.js
import React, { useContext, useEffect, useState } from 'react';
import { isValidDeltaOps, quillGetHTMLWithBlot, replaceMergeFieldsInHtml } from '../../../../../helpers/CommonFunctions';
import Quill from 'quill';
import ApplicationContext from '../../../../../context/ApplicationContext';

function Paragraph({ component}) {
    
    const [html, setHtml] = useState('Lorem Ipsum')
    const { mergeFieldValues } = useContext(ApplicationContext);

    useEffect(() => {
        if (!isValidDeltaOps(component.properties.textContent)) {
            console.warn("Delta is empty or default. Skipping full view paragraph generation.");
            return;
        }
        if (component.properties.textContent && typeof component.properties.textContent === "object") {
            const Delta = Quill.import('delta');
            const delta = new Delta(component.properties.textContent);
            // Conversion of Delta object into HTML
            const html = quillGetHTMLWithBlot(delta)
            const finalHTML = replaceMergeFieldsInHtml(html, mergeFieldValues)
            setHtml(finalHTML)
        } else if (component.properties.textContent && typeof component.properties.textContent === "string") {
            setHtml(component.properties.textContent)
        }
    }, [component.properties.textContent])

    return (
        <div className='form-quill h-full w-full'>
            <p 
                id={component.id} 
                dangerouslySetInnerHTML={{__html: html}}
                className={`cursor-default outline-none min-w-[50px] max-h-[1000px] max-w-[800px] overflow-hidden facility-profile break-words`} 
                style={{...component?.styles}}
            />
        </div>

    );
}

export default Paragraph;
